import { render, staticRenderFns } from "./UiExpandableSelector.vue?vue&type=template&id=1baa9398&scoped=true&"
import script from "./UiExpandableSelector.vue?vue&type=script&lang=js&"
export * from "./UiExpandableSelector.vue?vue&type=script&lang=js&"
import style0 from "./UiExpandableSelector.vue?vue&type=style&index=0&id=1baa9398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa9398",
  null
  
)

export default component.exports